/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Heading, IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import LinksComponent from './components/links';
import { IObrienContentBlockTeamProps} from './obrien-content-block-team.props.autogenerated';

export interface IContentBlockTeamViewProps extends IObrienContentBlockTeamProps<{}> {
    title?: React.ReactNode;
    text?: React.ReactNode;
    image?: React.ReactNode;
    links?: React.ReactNode;
    outboundLink?: string;
    className?: string;
    identifier?: string;
    contentBlockContainer: IModuleProps;
    imageContainer:INodeProps;
    detailsContainer:INodeProps;
}
/**
 *
 * ContentCard component
 * @extends {React.PureComponent<IObrienContentBlockTeamProps{}>}
 */

class ContentBlock extends React.PureComponent<IObrienContentBlockTeamProps<{}>> {
    public render(): JSX.Element | null {
        const { heading, paragraph, image, links, identifier, outboundLink, className} = this.props.config;
        const contentBlockTitle = heading && heading.text && <Heading className='obrien-content-block-Team__title' headingTag={heading.tag} text={heading.text} />;
        const imageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: image && image.imageSettings
        };
        const contentBlockLinks = links && links.length > 0 && <LinksComponent {...{ links }} />;
        const contentBlockText = paragraph && <Msdyn365.RichTextComponent text = {paragraph} className = 'obrien-content-block-Team__text' />;
        const contentBlockImage = image && <Msdyn365.Image {...image} {...imageProps} />;

        const OutboundLink = outboundLink ? outboundLink : '';

        if (!contentBlockTitle && !contentBlockText && !contentBlockImage && !contentBlockLinks) {
            return null;
        }

        const ContentBlockTeamviewProps = {
            ...this.props,
            title: contentBlockTitle,
            text: contentBlockText,
            image: contentBlockImage,
            outboundLink: OutboundLink,
            links: contentBlockLinks,
            identifier: this.props.config.identifier,
            moduleClass: this.props.config.className,
            contentBlockContainer: {
                moduleProps: this.props,
                id: identifier,
                className: classnames('ob-team-height', className)
            },
            imageContainer: {className: 'ob-team-img'},
            detailsContainer: {className: 'ob-team-title'}
        };

        return this.props.renderView(ContentBlockTeamviewProps) as React.ReactElement;
    }
}

export default ContentBlock;
